module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsYearly.bbbd330.jpg";